import React, { useState, useRef } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Tabs,
  Tab,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Divider,
  Modal,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Toolbar,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import PhoneIcon from "@mui/icons-material/Phone";

import { useInView } from "react-intersection-observer";
import "./MainPage.css";

import ContactSection from "./ContactSection"; // adjust path

const Overview = () => {
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.3 });
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedTabA, setSelectedTabA] = useState(0);
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const amenitiesData = [
    { title: "Terrace", icon: "/ameneties/Terrace.png" },
    { title: "Ample Parking", icon: "/ameneties/Parking.png" },
    { title: "Modular Kitchen", icon: "/ameneties/Kitchen.png" },
    { title: "BBQ Area", icon: "/ameneties/bbq.png" },
    { title: "Retail Center", icon: "/ameneties/retail.png" },
    { title: "24x7 Security & CCTV", icon: "/ameneties/security.png" },
    { title: "Outdoor Cabanas", icon: "/ameneties/cabanas.png" },
    { title: "Standby Generator", icon: "/ameneties/generator.png" },
    { title: "Inverter Backup", icon: "/ameneties/inverter_backup.png" },
    { title: "Refuse Chute", icon: "/ameneties/⁠Refuse_chute.png" },
    { title: "Intercom", icon: "/ameneties/intercom.png" },
  ];

  const ProjectData = [
    {
      title: "SEPAL VILLAS",
      status: "SOLD OUT",
      image: "/03.jpg",
    },
    {
      title: "SEPAL HEIGHTS",
      status: "SOLD OUT",
      image: "/p3.jpg",
    },
    {
      title: "SEPAL COURTS",
      status: "SOLD OUT",
      image: "/p4.png",
    },
    {
      title: "SEPAL ELITE",
      status: "SOLD OUT",
      image: "/p5.png",
    },
    {
      title: "SEPAL GRANDE",
      status: "SOLD OUT",
      image: "/p1.png",
    },
    {
      title: "SEPAL FUTURE",
      status: "UPCOMING",
      image: "/p3.jpg",
    },
  ];
  const unitTypes = [
    {
      name: "3 Bed Duplex",
      img: "/floorplans/3bhk_lower.png",
      // eslint-disable-next-line

      // upper: "/floorplans/3bhk.png",
      upper: "/floorplans/3bhk.png",
    },
    {
      name: "3 Bed",
      img: "/floorplans/3bhktypea.png",
      typeB: "/floorplans/3bhkb.png",
    },
    { name: "4 Bed", img: "/floorplans/4BHK.png" },
  ];

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChangeTabA = (event, newValue) => {
    setSelectedTabA(newValue);
  };

  const handleOpen = (imgSrc) => {
    setCurrentImage(imgSrc);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentImage(null);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
  const amenitiesRef = useRef(null);
  const unitTypesRef = useRef(null);
  const ProjectRef = useRef(null);
  // const locationRef = useRef(null)
  const ContactRef = useRef(null);

  // Scroll to the corresponding section
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  console.log(unitTypes);
  const renderUnitTypeContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <>
            <img
              src={unitTypes[0].img}
              alt={unitTypes[0].name}
              style={{ width: "100%", height: "auto", cursor: "pointer" }}
              onClick={() => handleOpen(unitTypes[0].img)}
            />
            <img
              src={unitTypes[0].upper}
              alt={unitTypes[0].name}
              style={{ width: "100%", height: "auto", cursor: "pointer" }}
              onClick={() => handleOpen(unitTypes[0].upper)}
            />
          </>
        );
      case 1:
        return (
          <div style={{ width: "100%" }}>
            <Tabs
              value={selectedTabA}
              onChange={handleChangeTabA}
              sx={tabStyles.vertical}
              orientation="vertical"
              variant="scrollable"
            >
              <Tab label="Type A" />
              <Tab label="Type B" />
            </Tabs>
            <img
              src={selectedTabA === 0 ? unitTypes[1].img : unitTypes[1].typeB}
              alt={`3 Bed Duplex ${selectedTabA === 0 ? "Type A" : "Type B"}`}
              style={{
                width: "100%",
                height: "auto",
                marginTop: 30,
                cursor: "pointer",
              }}
              onClick={() =>
                handleOpen(
                  selectedTabA === 0 ? unitTypes[1].img : unitTypes[1].typeB
                )
              }
            />
          </div>
        );
      case 2:
        return (
          <img
            src={unitTypes[2].img}
            alt={unitTypes[2].name}
            style={{ width: "100%", height: "auto", cursor: "pointer" }}
            onClick={() => handleOpen(unitTypes[2].img)}
          />
        );
      default:
        return null;
    }
  };

  const tabStyles = {
    vertical: {
      "& .MuiTab-root": {
        color: "white",
        backgroundColor: "transparent",
        "&.Mui-selected": {
          color: "wheat",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
      },
    },
    horizontal: {
      "& .MuiTab-root": {
        color: "white",
        backgroundColor: "transparent",
        borderBottom: "2px solid white",
        padding: "8px 16px",
        "&.Mui-selected": {
          color: "wheat",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          borderBottom: "2px solid wheat",
        },
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
      },
      display: "flex",
      justifyContent: "flex-start",
    },
  };

  const drawerContents = (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "#0e141e",
        color: "wheat",
        display: "flex",
        flexDirection: "column",
        px: 4,
        pt: 4,
      }}
      role="presentation"
      onClick={handleDrawerToggle}
      onKeyDown={handleDrawerToggle}
    >
      {/* Close Button */}
      <IconButton
        edge="end"
        aria-label="close"
        onClick={handleDrawerToggle}
        sx={{
          //alignSelf: "flex-end",
          color: "white",
          fontSize: 30,
          mb: 4,
        }}
      >
        <CloseIcon sx={{ fontSize: 30 }} />
      </IconButton>

      {/* Menu Items */}
      <List>
        {[
          { label: "AMENITIES", ref: amenitiesRef },
          { label: "UNIT TYPES", ref: unitTypesRef },
          { label: "PROJECTS", ref: ProjectRef },
        ].map((item, index) => (
          <ListItem
            button
            key={index}
            onClick={() => scrollToSection(item.ref)}
            sx={{ py: 3 }}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                sx: {
                  fontSize: "1.8rem",
                  fontFamily: "Beckman",
                  textAlign: "center",
                },
              }}
            />
          </ListItem>
        ))}
        <ListItem
          button
          onClick={() => (window.location.href = "/about-us")}
          sx={{ py: 3 }}
        >
          <ListItemText
            primary="ABOUT US"
            primaryTypographyProps={{
              sx: {
                fontSize: "1.8rem",
                fontFamily: "Beckman",
                textAlign: "center",
              },
            }}
          />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <Toolbar sx={{ px: 3, display: "flex", alignItems: "center" }}>
        <IconButton onClick={handleDrawerToggle} sx={{ color: "white" }}>
          <MenuIcon />
        </IconButton>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            marginTop: 2,
          }}
        >
          <img src="/S2.png" alt="Logo" style={{ height: 60 }} />
        </Box>
        <Box
          component="a"
          href="tel:+256705332050"
          sx={{
            color: "wheat",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            fontSize: { xs: "1rem", md: "1.25rem" },
            fontWeight: 500,
            "&:hover": {
              color: "#c5b891",
            },
          }}
        >
          <PhoneIcon sx={{ mr: 1, fontSize: { xs: "1.2rem", md: "1.5rem" } }} />
          +256705332050
        </Box>
      </Toolbar>
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: "#0e141e", // Matches your background
            color: "wheat",
            width: "100vw",
            height: "100vh",
          },
        }}
      >
        {drawerContents}
      </Drawer>

      <div className="overview-container">
        <Box
          className="cover-image-container"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "flex-start",
            px: 2,
            pt: 6,
            pb: 4,
            position: "relative",
            backgroundImage: {
              xs: "none",
              md: 'url("/sepalbanner.png")', // background image on desktop
            },
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: { md: "100vh" },
          }}
        >
          {/* Mobile Image Box */}
          <Box
            display={{ xs: "flex", md: "none" }}
            alignItems="center"
            justifyContent="center"
            mt={10}
          >
            <img
              src="/Sepal_Garden.png"
              alt="Sepal Garden"
              style={{ width: "100%" }}
            />
          </Box>

          {/* Content Over Background */}
          <Container>
            <Box mt={{ xs: 0, md: 15 }} ml={{ xs: 0, md: -50 }}>
              <Typography
                variant="h3"
                className="overview-text slide-in-right"
                sx={{
                  fontSize: {
                    xs: "4rem",
                    md: "4rem",
                    xl: "8rem",
                    fontFamily: "Beckman",
                  },
                }} // Increased font size
              >
                SEPAL
              </Typography>
              <Typography
                variant="h3"
                className="overview-text slide-in-right"
                sx={{
                  fontSize: {
                    xs: "4rem",
                    md: "4rem",
                    xl: "8rem",
                    fontFamily: "Beckman",
                  },
                }} // Increased font size
              >
                GARDEN
              </Typography>
              <Typography
                variant="h4"
                className="overview-text"
                sx={{
                  ml: 1,
                  color: "wheat",
                  fontSize: {
                    xs: "1.5rem",
                    md: "2rem",
                    fontFamily: "Beckman",
                  },
                }}
              >
                Project By Sruhad Investments
              </Typography>
              <Box mt={{ xs: 4, md: 8 }}>
                <Box display="flex" alignItems="center">
                  <LocationOnIcon
                    style={{ color: "wheat", fontSize: "2rem" }}
                  />
                  <Typography
                    variant="h4"
                    className="overview-text"
                    sx={{
                      ml: 1,
                      color: "wheat",
                      fontSize: {
                        xs: "1.5rem",
                        md: "2rem",
                        fontFamily: "Beckman",
                      },
                    }}
                  >
                    Bugolobi, Kampala
                  </Typography>
                </Box>
              </Box>
              <Box mt={4} display="flex" justifyContent="left">
                <Button
                  variant="outlined"
                  sx={{
                    fontFamily: "Beckman",
                    borderColor: "white",
                    color: "white",
                    px: 4,
                    py: 2,
                    fontSize: { xs: "1rem", md: "1.25rem" },
                    width: { xs: "100%", md: 300 },
                    mt: { xs: 4, md: 8 },
                  }}
                  onClick={() => scrollToSection(ContactRef)}
                >
                  Book Now
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>

        <div style={{ marginTop: 20 }}>
          <Divider
            sx={{
              width: "90%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "1px",
            }}
          />
        </div>

        {/* Sepal Garden */}
        <Container className="amenities-section">
          <Box display="flex" justifyContent="center" alignItems="center">
            <img
              src="/building.png"
              alt="Logo"
              style={{ height: 100, marginTop: 20 }}
            />
          </Box>

          <Typography
            variant="h3"
            align="center"
            sx={{ mb: 4, color: "white", marginTop: 3, fontFamily: "Beckman" }}
          >
            SEPAL GARDEN
          </Typography>
          <Divider
            sx={{
              width: "30%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "3px",
            }}
          />
          <Typography
            variant="h5"
            align="center"
            sx={{
              mb: 4,
              color: "wheat",
              marginTop: 5,
              fontSize: { xs: "1rem", md: "2rem", fontFamily: "Beckman" },
            }}
          >
            Our latest project Sepal Garden features 40 exquisite residential
            units designed for luxury affordable living. Nestled in a serene
            location, Sepal Garden offers stylish, modern homes with top-notch
            amenities and thoughtful design. Each unit is crafted to provide
            comfort and elegance while maintaining affordability. Enjoy spacious
            spaces, various facilities, and a vibrant community, all at your
            doorstep. Experience the perfect blend of sophistication and value
            at Sepal Garden, where your ideal home awaits. Discover a vibrant
            community and a new standard of living with us.
          </Typography>
        </Container>

        <section ref={amenitiesRef}>
          <Container className="amenities-section">
            <Typography
              sx={{
                mb: 4,
                color: "white",
                marginTop: 20,
                fontFamily: "Beckman",
              }}
              variant="h3"
              align="center"
            >
              AMENITIES
            </Typography>
            <Divider
              sx={{
                width: "20%",
                backgroundColor: "wheat",
                margin: "0 auto",
                borderBottomWidth: "3px",
              }}
            />

            <Box className="amenity-grid">
              {amenitiesData.map((amenity, index) => (
                <Box key={index} className="amenity-card">
                  <img src={amenity.icon} alt={amenity.title} />
                  <Typography className="amenity-card-title">
                    {amenity.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Container>
        </section>

        {/* FlooorPlans Section */}
        <section ref={unitTypesRef}>
          <Container className="amenities-section">
            <Box
              ref={ref2}
              className={`fade-in-section ${inView2 ? "is-visible" : ""}`}
              px={{ xs: 2, md: 20 }}
            >
              <Box textAlign="center">
                <Typography
                  sx={{ fontFamily: "Beckman" }}
                  variant="h3"
                  gutterBottom
                  paragraph
                  color={"white"}
                >
                  UNIT TYPES
                </Typography>
                <Divider
                  sx={{
                    width: "20%",
                    backgroundColor: "wheat",
                    margin: "0 auto",
                    borderBottomWidth: "3px",
                  }}
                />
                <Box mt={10} display="flex" justifyContent="center">
                  <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    sx={tabStyles.horizontal}
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab label="3 BHK Duplex" />
                    <Tab label="3 BHK" />
                    <Tab label="4 BHK" />
                  </Tabs>
                </Box>
                <Box
                  mt={4}
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  alignItems="center"
                >
                  {renderUnitTypeContent()}
                </Box>
              </Box>
            </Box>
          </Container>

          <Modal
            open={open}
            onClose={handleClose}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box sx={{ position: "relative", width: "90%", maxWidth: 1000 }}>
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "white",
                  zIndex: 2,
                }}
              >
                <CloseIcon />
              </IconButton>
              <img
                src={currentImage}
                alt="Full Screen"
                style={{ width: "100%", height: "auto" }}
              />
            </Box>
          </Modal>
        </section>

        {/* Project Section */}

        <div style={{ marginTop: 20 }}>
          <Divider
            sx={{
              width: "90%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "1px",
            }}
          />
        </div>
        <section ref={ProjectRef}>
          <Container
            maxWidth={false}
            disableGutters
            className="amenities-section"
          >
            <Grid
              container
              spacing={4}
              justifyContent="center"
              sx={{ marginTop: 10, px: 4 }} // Add a little horizontal padding manually
            >
              {ProjectData.map((project, index) => (
                <Grid
                  item
                  xs={16}
                  sm={6}
                  md={4} // ✅ 3 per row on medium+
                  key={index}
                  display="flex"
                  justifyContent="center"
                >
                  {" "}
                  <Card
                    sx={{
                      width: 420,
                      height: 540,
                      backgroundColor: "#151E28",
                      borderRadius: "16px",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 0 25px rgba(255, 255, 255, 0.08)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 0 30px rgba(255, 255, 255, 0.2)",
                      },
                    }}
                  >
                    {/* Status Badge */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        backgroundColor:
                          project.status === "SOLD OUT" ? "#d32f2f" : "#388e3c",
                        color: "#fff",
                        px: 2,
                        py: 0.3,
                        fontSize: "0.7rem",
                        fontWeight: "bold",
                        borderRadius: "4px",
                        zIndex: 1,
                      }}
                    >
                      {project.status}
                    </Box>

                    <CardMedia
                      component="img"
                      image={project.image}
                      alt={project.title}
                      sx={{
                        width: "90%",
                        height: 480,
                        objectFit: "cover",
                      }}
                    />

                    <CardContent sx={{ textAlign: "center", mt: 2 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontFamily: "Beckman",
                          color: "wheat",
                          textTransform: "uppercase",
                        }}
                      >
                        {project.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </section>

        {/* Location Section */}

        <div style={{ marginTop: 20 }}>
          <Divider
            sx={{
              width: "90%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "1px",
            }}
          />
        </div>
        <Container className="amenities-section">
          <Typography
            sx={{ mb: 4, color: "white", marginTop: 20, fontFamily: "Beckman" }}
            variant="h3"
            gutterBottom
            paragraph
            align="center"
            color={"white"}
          >
            LOCATION
          </Typography>
          <Divider
            sx={{
              width: "30%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "3px",
            }}
          />

          <div style={{ textAlign: "center", marginLeft: 20, marginRight: 20 }}>
            <img
              src="/darkmap.png"
              alt="Logo"
              style={{ width: "100%", height: "auto", marginTop: 30 }}
            />
            {/* Adjusted margins for responsiveness */}
          </div>
        </Container>
        {/* ABout Us Section */}

        <div style={{ marginTop: 20 }}>
          <Divider
            sx={{
              width: "90%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "1px",
            }}
          />
        </div>
        <section ref={ContactRef}>
          <Container className="amenities-section">
            <Typography
              sx={{
                mb: 4,
                color: "white",
                marginTop: 20,
                fontFamily: "Beckman",
              }}
              variant="h3"
              gutterBottom
              paragraph
              align="center"
              color={"white"}
            >
              CONTACT US
            </Typography>
            <Divider
              sx={{
                width: "30%",
                backgroundColor: "wheat",
                margin: "0 auto",
                borderBottomWidth: "3px",
              }}
            />
            <ContactSection />
          </Container>
        </section>
        <div style={{ marginTop: 20 }}>
          <Divider
            sx={{
              width: "90%",
              backgroundColor: "wheat",
              margin: "0 auto",
              borderBottomWidth: "1px",
            }}
          />
        </div>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 50 }}
        >
          <Typography
            variant="h6"
            sx={{
              ml: 1,
              color: "grey",
              fontFamily: "Beckman",
              fontSize: { xs: "0.7rem", md: "1rem" },
            }}
          >
            © 2024 Kenayo Consultancy Services Private Limited. All rights
            reserved.
          </Typography>
        </Box>
      </div>
    </>
  );
};

export default Overview;
